import { render, staticRenderFns } from "./AccountSidebarTab.vue?vue&type=template&id=266640ac&scoped=true&"
import script from "./AccountSidebarTab.vue?vue&type=script&lang=ts&"
export * from "./AccountSidebarTab.vue?vue&type=script&lang=ts&"
import style0 from "./AccountSidebarTab.vue?vue&type=style&index=0&id=266640ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266640ac",
  null
  
)

export default component.exports